import { GET_CARD_APPLY_ERROR, GET_CARD_APPLY_START, GET_CARD_APPLY_SUCCESS } from '../../types';

export default function get_card_apply(state, action) {
  switch (action.type) {
    case GET_CARD_APPLY_START:
      return { ...state };
    case GET_CARD_APPLY_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case GET_CARD_APPLY_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}
